<template>
    <div>
        <div v-if="mode=='div'" class="wxl-btn" :class="[type,size]" @click.stop="click">{{ text }}
            <slot />
        </div>
        <button v-if="mode=='button'" class="wxl-btn clear-button-def-style" :class="[type,size]" @click.stop="click">
            {{ text }}
            <slot />
        </button>
    </div>
</template>

<script>
    export default {
        name: 'wxl-btn',
        props: {
            text: String,
            type: {
                type: String,
                default: 'info'
            },
            mode: {
                type: String,
                default: 'div'
            },
            size: {
                type: String,
                default: 'normal'
            }
        },
        methods: {
            click: function() {
                this.$emit('click')
            }
        }
    }
</script>

<style lang="less" scoped>
    @import '@/styles/common.less';
    @import '@/styles/color.less';
    @import '@/styles/size.less';
    .wxl-btn {
        display: block;
        margin-bottom: 0;
        font-size: @fontsize;
        text-align: center;
        // padding: 0 12px;
        border-radius: 4px;
        margin: 0 15px;
        color:  @main;
        user-select: none;
        width: calc(100% - 24px);
    }
    .wxlBtn(@class,@color,@activecolor,@fontcolor){
        .@{class}{
            color: @fontcolor;
            background: @color;
            &:active{
                background: @activecolor;
            }
        }
    }
    .wxlBtn(default,@grey,tint(@grey,20%),@main);
    .wxlBtn(primary,@primary,tint(@primary,20%),@white);
    .wxlBtn(success,@success,tint(@success,20%),@white);
    .wxlBtn(info,@info,tint(@info,20%),@white);
    .wxlBtn(warning,@warning,tint(@warning,20%),@white);
    .wxlBtn(danger,@danger,tint(@danger,20%),@white);

    .Size(@class,@size){
        .@{class}{
            height:@size;
            line-height: @size+1px;
        }
    }
    .Size(normal, 40px);
    .Size(mini, 24px);
</style>
